var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomNavPlusTrue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.77778 1C3.5868 1 1 3.5868 1 6.77778V21.2222C1 24.4132 3.5868 27 6.77778 27H21.2222C24.4132 27 27 24.4132 27 21.2222V6.77778C27 3.5868 24.4132 1 21.2222 1H6.77778ZM20.4651 11H19.5358C19.3782 11 19.2505 10.8722 19.2505 10.7146V8.74925H17.2854C17.1278 8.74925 17 8.62149 17 8.46389V7.5346C17 7.37701 17.1278 7.24925 17.2854 7.24925H19.2505V5.28536C19.2505 5.12776 19.3782 5 19.5358 5H20.4651C20.6227 5 20.7505 5.12776 20.7505 5.28536V7.24925H22.7146C22.8722 7.24925 23 7.37701 23 7.53461V8.46389C23 8.62149 22.8722 8.74925 22.7146 8.74925H20.7505V10.7146C20.7505 10.8722 20.6227 11 20.4651 11ZM16.1763 10.3057L16.1765 10.3052C15.5285 10.0732 14.8267 9.93555 14.0926 9.93555C12.9832 9.93555 11.9478 10.2339 11.0512 10.7453V15.9659C11.0512 14.3038 12.4117 12.9543 14.0926 12.9543C14.4584 12.9543 14.8102 13.0237 15.1329 13.1421L15.133 13.1418C16.2996 13.5634 17.1338 14.6666 17.1338 15.9686C17.1338 17.6307 15.7733 18.9802 14.0924 18.9802C12.4115 18.9802 11.051 17.6331 11.051 15.9686V10.7456V8.51055C11.051 7.67714 10.3671 7 9.52548 7C8.68384 7 8 7.67714 8 8.51055V15.9662C8 19.2975 10.7258 21.9966 14.09 21.9966C17.4542 21.9966 20.1847 19.2975 20.1847 15.9662C20.1847 13.36 18.5116 11.1489 16.1763 10.3057Z",
    fill: "#004FEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomNavPlusTrue);
export default __webpack_public_path__ + "static/media/bottom_nav_plus_true.fdac6e8ad8ae1b1dd799e440767b0034.svg";
export { ForwardRef as ReactComponent };